<template>
  <div class="container-fluid">
    <div class="row mb-3">
      <div class="col-12">
        <h1>Real-Time OSRS GE Margins</h1>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-2 col-sm-12 mb-3">
        <div class="card">
          <div class="card-body px-0">
            <InArticleAdsense
              style="display:block; text-align:center;"
              data-ad-layout="display"
              data-ad-format="auto"
              data-ad-client="ca-pub-6075100011305267"
              data-ad-slot="1813678651"
              :is-non-personalized-ads="false"
              :data-full-width-responsive="true">
            </InArticleAdsense>
          </div>
        </div>
      </div>

      <div class="col-md-8 col-sm-12">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <h2 class="mb-4">Best Margins</h2>

                <form class="config row mb-2" @submit="setConfig">
                  <div class="col-md col-sm-12">
                    <label>Min Price</label>
                    <input class="form-control" placeholder="Min Price" v-model="currentConfig.minPrice">
                  </div>
                  <div class="col-md col-sm-12">
                    <label>Max Price</label>
                    <input class="form-control" placeholder="Max Price" v-model="currentConfig.maxPrice">
                  </div>
                  <div class="col-md col-sm-12">
                    <label>Max Margin</label>
                    <input class="form-control" placeholder="Max Margin" v-model="currentConfig.maxMargin">
                  </div>
                  <div class="col-md col-sm-12">
                    <label>Last Traded (minutes)</label>
                    <input class="form-control" placeholder="Item freshness" v-model="currentConfig.itemFreshness">
                  </div>
                  <div class="col-md col-sm-12">
                    <label>Check interval (seconds)</label>
                    <input class="form-control" placeholder="Item freshness" v-model="currentConfig.checkInterval">
                  </div>

                  <div class="col-md col-sm-12">
                    <button class="btn btn-primary btn-block" @click="setConfig">Update</button>
                  </div>
                </form>

                <div v-show="loaded">
                  <MarginTable :item-list="this.items" :realtime-data="this.data" :min-price="this.config.minPrice"
                               :max-price="this.config.maxPrice" :max-margin="this.config.maxMargin"
                               :item-freshness="this.config.itemFreshness"
                  ></MarginTable>
                </div>


                <div v-show="!loaded">
                  Loading Prices...
                </div>


              </div>
            </div>
          </div>
        </div>

      </div>


      <div class="col-md-2 col-sm-12 mb-3">
        <div class="card">
          <div class="card-body px-0">
            <InArticleAdsense
              style="display:block; text-align:center;"
              data-ad-layout="display"
              data-ad-format="fluid"
              data-ad-client="ca-pub-6075100011305267"
              data-ad-slot="9059640718"
              :is-non-personalized-ads="false"
              :data-full-width-responsive="true">
            </InArticleAdsense>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MarginTable from "../components/margins/MarginTable";

  export default {
    name: "Roadmap",
    components: {MarginTable},
    data() {
      return {
        latestUri: 'https://prices.runescape.wiki/api/v1/osrs/latest',
        itemsUri: 'https://www.osrsbox.com/osrsbox-db/items-summary.json',
        data: {},
        items: {},
        loaded: false,
        poller: null,
        lastUpdated: 0,
        config: {
          minPrice: 0,
          maxPrice: 0,
          maxMargin: 0,
          itemFreshness: 0,
          checkInterval: 60,
        },
        currentConfig: {
          minPrice: 0,
          maxPrice: 0,
          maxMargin: 0,
          itemFreshness: 0,
          checkInterval: 60,
        }
      }
    },
    methods: {
      getItems() {
        this.$http.get(this.itemsUri).then((resp) => {
          this.items = resp.data;
          this.getData();
        })
      },

      getData() {
        console.log('Getting latest data');
        this.$http.get(this.latestUri).then((resp) => {
          this.data = resp.data.data;
          this.loaded = true;
          this.lastUpdated++;
        })
      },

      setConfig(e) {
        e.preventDefault();
        if (this.config.checkInterval !== this.currentConfig.checkInterval) {
          this.poller = null;
          this.startDataPolling(this.currentConfig.checkInterval);
        }

        this.config = {
          minPrice: this.currentConfig.minPrice,
          maxPrice: this.currentConfig.maxPrice,
          maxMargin: this.currentConfig.maxMargin,
          itemFreshness: this.currentConfig.itemFreshness,
          checkInterval: this.currentConfig.checkInterval,
        };
      },

      startDataPolling(interval) {
        console.log('Polling latest with interval of:', (interval * 1000));
        this.poller = setInterval(this.getData, (interval * 1000))
      }
    },
    mounted() {
      this.getItems();
      this.startDataPolling(this.currentConfig.checkInterval);
    }
  }
</script>

<style scoped>
  .card {
    border-color: #3F3529;
  }

  label {
    font-size: 0.8rem;
  }

  .updateBtn {
    position: absolute;
    bottom: 0;
    width: 80%;
    margin-right: 30px;
  }

  .card-body {
    color: black;
    font-size: 1.3rem;
    background: #5B5545;
  }
</style>



// WEBPACK FOOTER //
// src/pages/MarginsRealtime.vue